<div class="modal">

  <button app-button buttonType="text" buttonTheme="light" type="button" (click)="closeDialog()" title="Close" [attr.aria-label]="'Close'" class="modal__close">
    <app-icon icon="times" size="lg">
    </app-icon>
  </button>

  <div
    class="modal__contents"
    [style.height]="height + 'px'">

    <iframe
      *ngIf="src"
      [src]="src"
      class="modal__frame">
    </iframe>

  </div>

</div> 